import { render, staticRenderFns } from "./userRoles.vue?vue&type=template&id=116d39af&scoped=true"
import script from "./userRoles.vue?vue&type=script&lang=js"
export * from "./userRoles.vue?vue&type=script&lang=js"
import style0 from "./userRoles.vue?vue&type=style&index=0&id=116d39af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d39af",
  null
  
)

export default component.exports